<template>
  <div class="page-dialog add-dialog">
    <el-form
      ref="form"
      :model="terminalAdd"
      label-position="right"
      :inline="true"
      size="mini"
      :rules="rules"
    >
      <el-row>
        <el-col :lg="8" :md="12">
          <el-form-item prop="REGION" label="省" style="margin-bottom: 20px;">
            <el-select v-model="terminalAdd.REGION" @change="changeArea($event, 'city')">
              <el-option
                v-for="item in selectDataOptions['regionList']"
                :key="item.BLAND"
                :value="item.BLAND"
                :label="item.BEZEI"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item prop="CITY_CODE" label="市">
            <el-select v-model="terminalAdd.CITY_CODE" @change="changeArea($event, 'street')">
              <el-option
                v-for="item in selectDataOptions['cityList']"
                :key="item.CITY_CODE"
                :value="item.CITY_CODE"
                :label="item.CITY_NAME"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item prop="STREET_CODE" label="区">
            <el-select v-model="terminalAdd.STREET_CODE" @change="changeArea($event, 'q')">
              <el-option
                v-for="item in selectDataOptions['streetList']"
                :key="item.STRT_CODE"
                :value="item.STRT_CODE"
                :label="item.MC_STREET"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item prop="STREET" label="详细地址">
            <el-input v-model="terminalAdd.STREET" clearable />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { getArea } from '@/api/sap/common-sap'
export default {
  props: {
    addressData: {
      type: Object,
      default: null
    },
    areaType: {
      type: String,
      default: 'ZDZG' // 默认终端直配类型，普通要货不传或传空
    }
  },
  data() {
    return {
      selectDataOptions: {
        cityList: [],
        streetList: [],
        regionList: []
      },
      terminalAdd: {
        REGION: '',
        REGION_TEXT: '',
        CITY_CODE: '',
        CITY_TEXT: '',
        STREET_CODE: '',
        STREET_TEXT: '',
        STREET: ''
      },
      rules: {
        REGION: [{ required: true, message: '请选择省', trigger: 'change' }],
        CITY_CODE: [{ required: true, message: '请选择市', trigger: 'change' }],
        STREET_CODE: [{ required: true, message: '请选择区', trigger: 'change' }],
        STREET: [{ required: true, message: '请填写详细地址', trigger: 'change' }]
      }
    }
  },
  computed: {},
  created() {
    this.getAreaArr()
    // 如果有传入初始地址数据，使用传入的数据
    if (this.addressData) {
      this.terminalAdd = { ...this.addressData }
      // 如果有初始值，需要加载对应的城市和区县数据
      if (this.addressData.REGION) {
        this.loadCityData(this.addressData.REGION)
      }
      if (this.addressData.CITY_CODE) {
        this.loadStreetData(this.addressData.CITY_CODE)
      }
    }
  },
  methods: {
    async changeArea(e, type) {
      if (e) {
        if (type === 'city') {
          // 根据 areaType 决定是否传入第三个参数
          const params = this.areaType ? [e, type, this.areaType] : [e, type]
          const { DATA } = await getArea(...params)
          this.selectDataOptions.cityList = DATA
          this.terminalAdd.REGION_TEXT = this.selectDataOptions['regionList'].find(
            v => v.BLAND === e
          )?.BEZEI
          this.terminalAdd.CITY_CODE = ''
          this.terminalAdd.STREET_CODE = ''
          this.terminalAdd.CITY_TEXT = ''
          this.terminalAdd.STREET_TEXT = ''
          this.terminalAdd.STREET = ''
          this.selectDataOptions.streetList = []
        } else if (type === 'street') {
          const { DATA } = await getArea(e, type)
          this.selectDataOptions.streetList = DATA
          this.terminalAdd.STREET_CODE = ''
          this.terminalAdd.STREET_TEXT = ''
          this.terminalAdd.CITY_TEXT = this.selectDataOptions['cityList'].find(
            v => v.CITY_CODE === e
          )?.CITY_NAME
        } else {
          this.terminalAdd.STREET_TEXT = this.selectDataOptions['streetList'].find(
            v => v.STRT_CODE === e
          )?.MC_STREET
        }
      }
    },
    async loadCityData(region) {
      if (region) {
        const params = this.areaType ? [region, 'city', this.areaType] : [region, 'city']
        const { DATA } = await getArea(...params)
        this.selectDataOptions.cityList = DATA
        this.terminalAdd.REGION_TEXT = this.selectDataOptions['regionList'].find(
          v => v.BLAND === region
        )?.BEZEI
      }
    },
    async loadStreetData(cityCode) {
      if (cityCode) {
        const { DATA } = await getArea(cityCode, 'street')
        this.selectDataOptions.streetList = DATA
        this.terminalAdd.CITY_TEXT = this.selectDataOptions['cityList'].find(
          v => v.CITY_CODE === cityCode
        )?.CITY_NAME
        if (this.terminalAdd.STREET_CODE) {
          this.terminalAdd.STREET_TEXT = this.selectDataOptions['streetList'].find(
            v => v.STRT_CODE === this.terminalAdd.STREET_CODE
          )?.MC_STREET
        }
      }
    },
    // 省
    getAreaArr() {
      const params = this.areaType ? ['', 'region', this.areaType] : ['', 'region']
      getArea(...params).then(res => {
        this.selectDataOptions['regionList'] = res.DATA
      })
    },
    // 用于弹窗提交时 回调数据
    async submitForm() {
      const bool = await this.$refs.form.validate()
      if (bool) {
        return Promise.resolve(this.terminalAdd)
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-dialog {
  margin-bottom: 40px;
}
.add-dialog .el-form .el-form-item {
  margin-bottom: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/components/receiveAddress.vue